<template>
  <div class="operation-area-inside" id="operation-area" :class="themeClass">
    <!-- 左边的操作 -->
    <div class="left-warp">
      <!--撤销-->
      <div class="left-warp-item revoke" @click="handleRetreat(0)">
        <i class="icon"></i>
        <span class="text">撤销</span>
      </div>
      <!--恢复-->
      <div class="split-line"></div>
      <div class="left-warp-item recovery" @click="handleAdvance">
        <i class="icon"></i>
        <span class="text">重做</span>
      </div>
      <!-- 加粗，倾斜，下划线，删除线，上下标 -->

      <!--查找/替换-->
      <div class="split-line"></div>
      <div class="left-warp-item find-replace" @click="handleClick('first')">
        <i class="icon"></i>
        <span class="text">查找/替换</span>
      </div>

      <!-- <template v-if="!(getUrlTypeInfo==='school')"> -->
      <!--拆分句对-->
      <div class="split-line"></div>
      <div class="left-warp-item split" v-throttle="handleSplitFrangment">
        <i class="icon"></i>
        <span class="text">拆分</span>
      </div>
      <!--向下合并-->
      <div class="split-line"></div>
      <div class="left-warp-item down-merge" v-throttle="handleDownMerge">
        <i class="icon"></i>
        <span class="text">合并</span>
      </div>
      <!--复制到译文-->
      <div class="split-line"></div>
      <div class="left-warp-item copy-target" @click="handleCopyToTarget">
        <i class="icon"></i>
        <span class="text">复制原文至译文</span>
      </div>
      <!--自动填充标记-->
      <div class="split-line"></div>
      <div class="left-warp-item position-tag" @click="handleAutoFillTag">
        <i class="icon"></i>
        <span class="text">自动填充标记</span>
      </div>
      <!--编辑原文-->
      <div class="split-line"></div>
      <div class="left-warp-item edit-source" @click="handlesource">
        <i class="icon"></i>
        <span class="text">编辑原文</span>
      </div>
      <!--预翻译-->
      <template v-if="haveResetTrans && isPreMt">
        <div class="split-line"></div>
        <div
          class="left-warp-item pre-translation"
          @click="handleAfreshTranslate"
        >
          <i class="icon"></i>
          <span class="text">重新机翻</span>
        </div>
      </template>
      <!-- </template> -->

      <!--字体缩放-->
      <div class="split-line"></div>
      <el-popover
        trigger="click"
        placement="bottom"
        class="font-zoom-wrap"
        popper-class="font-zoom-wrap2"
      >
        <div class="font-zoom-inside">
          <el-slider
            :step="2"
            :min="12"
            :max="20"
            show-stops
            :show-tooltip="false"
            :marks="getfontSizeList"
            @input="hendleChange"
            v-model="value4"
          />
        </div>
        <div slot="reference" class="left-warp-item font-size">
          <i class="icon"></i>
          <span class="text">字体大小</span>
        </div>
      </el-popover>
      <!--筛选-->
      <template
        v-if="getUrlTypeInfo !== 'project' && getUrlTypeInfo !== 'school'"
      >
        <div class="split-line"></div>
        <el-popover
          trigger="click"
          placement="bottom"
          class="competition-selection-wrap"
          popper-class="competition-selection-wrap"
        >
          <div class="competition-selection-inside">
            <el-row class="competition-selection-box">
              <el-col :span="24" class="item">
                <div class="left">句段状态</div>
                <div class="right">
                  <el-select
                    v-model="value"
                    placeholder="请选择"
                    size="small"
                    @change="(e) => handleChange(e, 'transStatus')"
                  >
                    <el-option
                      v-for="item in getscreenOptionsList.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="24" class="item">
                <div class="left">备注</div>
                <div class="right">
                  <el-select
                    v-model="value2"
                    placeholder="请选择"
                    size="small"
                    @change="(e) => handleChange(e, 'hasComment')"
                  >
                    <el-option
                      v-for="item in getscreenOptionsList.options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="24" class="item">
                <div class="left">锁定重复内容</div>
                <div class="right">
                  <el-select
                    v-model="value3"
                    placeholder="请选择"
                    size="small"
                    @change="(e) => handleChange(e, 'hasRepeatLock')"
                  >
                    <el-option
                      v-for="item in getscreenOptionsList.options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
          </div>
          <div slot="reference" class="left-warp-item competition-selection">
            <i class="icon"></i>
            <span class="text">筛选</span>
          </div>
        </el-popover>
      </template>
      <!--编辑模式-->
      <div class="split-line"></div>
      <el-popover
        trigger="click"
        placement="bottom"
        class="mark-mode-wrap"
        popper-class="mark-mode-wrap2"
      >
        <div class="setting-mode-wrap">
          <el-radio-group v-model="mark_value" @change="handleEditorModeChange">
            <el-row class="setting-mode">
              <el-col :span="24">
                <el-radio label="standard">标准模式</el-radio>
              </el-col>
              <el-col :span="24" v-if="haveMarkMode">
                <el-radio label="mark">修订模式</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div slot="reference" class="left-warp-item mark-mode">
          <i class="icon"></i>
          <span class="text">编辑模式</span>
        </div>
      </el-popover>
      <!--添加术语-->
      <!-- <template v-if="getUrlTypeInfo !== 'school'"> -->
      <template>
        <div class="split-line"></div>
        <div class="left-warp-item add-terms" @click="handleClick('second')">
          <i class="icon"></i>
          <span class="text">添加术语</span>
        </div>
      </template>
      <!--显示模式-->
      <template v-if="!(getUrlTypeInfo === 'school')">
        <div class="split-line"></div>
        <div slot="reference" class="left-warp-item view-mode">
          <div class="icon-list">
            <i
              v-for="item in editorViewMode"
              :key="item.id"
              v-show="item.isShow"
              @click="handleChangeViewMode(item)"
              class="icon"
              :class="item.iconClass"
              :title="item.title"
            ></i>
          </div>
          <span class="text">显示模式</span>
        </div>
      </template>
    </div>
    <!-- 右边的操作 评分相关操作 -->
    <div class="right-warp" v-if="isShowScoreRight">
      <template v-if="isShowScoreBtn">
        <div class="right-warp-item" @click="redoVisible = true">
          <i class="icon return-to-redo"></i>
          <span class="text" style="color: #ff6969">退回重做</span>
        </div>
        <div class="split-line"></div>
        <div class="right-warp-item" @click="scoreVisible = true">
          <i class="icon score"></i>
          <span class="text" style="color: #0078fc">评价评分</span>
        </div>
      </template>
      <template v-if="isShowEvaluated">
        <div class="right-warp-item">
          <i class="icon evaluated"></i>
          <span class="text" style="color: #bfbfbf">已评价</span>
        </div>
      </template>
    </div>
    <!-- 右侧退回任务及验收 -->
    <div
      class="right-warp right-warp__task"
      v-if="isShowBankTask || isShowAccepted"
    >
      <template v-if="isShowBankTask">
        <div class="right-warp-item" @click="handleBankTask">
          <i class="icon bank-task"></i>
          <span class="text">退回任务</span>
        </div>
      </template>
      <div class="split-line" v-show="isShowBankTask && isShowAccepted"></div>
      <template v-if="isShowAccepted">
        <div class="right-warp-item" @click="acceptedVisible = true">
          <i class="icon acceptance"></i>
          <span class="text">验收</span>
        </div>
      </template>
    </div>
    <score-dialog
      :dialogVisible="scoreVisible"
      title="确认评价"
      @handleClose="handleScoreClose"
      @handleConfirm="handleScoreConfirm"
    >
    </score-dialog>
    <return-to-redo-dialog
      :dialogVisible="redoVisible"
      @handleClose="handleRedoClose"
      @handleConfirm="handleRedoConfirm"
    >
    </return-to-redo-dialog>
    <!-- 任务退回选择弹窗 -->
    <bank-task-select-dialog
      :dialogVisible="bankTaskVisible"
      @handleClose="handleBankTaskClose"
      @handleConfirm="handleBankTaskConfirm"
    >
    </bank-task-select-dialog>
    <!-- 验收弹窗 -->
    <base-dialog
      :dialogVisible="acceptedVisible"
      :showClose="false"
      custom-class="accepted-dialog"
      @handleConfirm="handleAcceptedConfirm"
      @handleClose="handleAcceptedClose"
    >
      <template #title>验收</template>
      是否确认验收？
    </base-dialog>
  </div>
</template>

<script>
import { eventUtil } from "@/components/editor/modules/eventUtil";
import { mapGetters } from "vuex";
import {
  rollBackTaskToSent,
  rollBackTask,
  acceptanceTask,
} from "@/services/editorApi";
import ScoreDialog from "./components/score-dialog";
import returnToRedoDialog from "./components/return-to-redo-dialog";
import BankTaskSelectDialog from "./components/bank-task-select-dialog";
import BaseDialog from "@/common/base-dialog";
// import editorMixin from "../editorArea/modules/editorContrast/common/mixin";
export default {
  name: "EditorOperation",
  props: ["editorMode"],
  components: {
    BaseDialog,
    ScoreDialog,
    returnToRedoDialog,
    BankTaskSelectDialog,
  },
  // mixins: [editorMixin],
  data() {
    return {
      haveResetTrans: haveResetTrans,
      haveMarkMode: haveMarkMode,
      value: "",
      value2: "",
      value3: "",
      value4: null,
      // queryData: {},
      radio: "",
      filterType: "",
      number: 0,
      mark_value: this.editorMode,
      isFirst: true,
      // activeMode: "third", //编辑模式
      queryRouteInof: {},
      suffix: ["ppt", "pptx", "html", "xlf", "htm", "eml"],
      editorViewMode: [
        {
          id: 1,
          name: "newEditor",
          title: "表格对照",
          iconClass: "table-icon",
          isShow: true,
        },
        {
          id: 2,
          name: "wordEditorTier",
          title: "上下对照",
          iconClass: "up-down-icon",
          isShow: true,
        },
        {
          id: 3,
          name: "editor",
          title: "左右对照",
          iconClass: "left-right-icon",
          isShow: true,
        },
      ],
      scoreVisible: false,
      redoVisible: false,
      bankTaskVisible: false,
      acceptedVisible: false,
      fileinfo: {},
      timer: null,
    };
  },

  computed: {
    ...mapGetters("editor", [
      "getEditorModeInfo", // 当前编辑器模式 标准/修订
      "evaluationResults", // 评分结果
      "getFileTaskInfo", // 文件任务信息
      "getFileInfo", // 文件信息
      "getUrlInfo", // url信息
      "getThemeInfo", // 编辑器当前主题
      "getProjectInfo", // 获取项目信息
      "getfontSizeList", // 文字大小
      "getscreenOptionsList", // 筛选文字设置选项
      "importOption", // 导出选项
      "getRevokeInfo", // 撤销的数据
      "getRecoveryInfo", // 恢复
      "getTempSentenceIdInfo", // 获取句子临时信息
      "getEleStatus", // 获取检索编辑状态
      "getTaskContentList", // 获取编辑器文件list ( 文件内容列表 )
      "getUserInfo", // 获取当前用户的信息
    ]),
    getEditorRightShownInfo: function () {
      const self = this;
      let editorShownInfo = JSON.parse(
        JSON.stringify(self.$store.getters["editor/getEditorRightShownInfo"])
      );
      return editorShownInfo;
    },
    /**
     * @desc 是否开启机翻 渲染机翻图标
     * @return {boolean}
     */
    isPreMt() {
      const { isPreMt } = this.getProjectInfo;
      return isPreMt ? true : false;
    },

    /**
     * @desc 是否渲染已评价图标
     * @return {boolean}
     */
    isShowEvaluated() {
      const { scoreStatus } = this.evaluationResults;
      if (scoreStatus !== 1) {
        return false;
      }
      const { identityType } = JSON.parse(localStorage.getItem("userInfo"));
      if (![1, 2, 3].includes(parseInt(identityType))) {
        return false;
      }
      return true;
    },

    /**
     * @desc 是否渲染退回重做及评分评价按钮
     * @return {boolean}
     */
    isShowScoreBtn() {
      // console.log('@@@',this.getUrlInfo.toGrade , this.evaluationResults.scoreStatus);
      // scoreStatus 未评价0 已评价1
      const { scoreStatus } = this.evaluationResults;
      if (scoreStatus) {
        return false;
      }

      const { toGrade } = this.getUrlInfo;
      if (!toGrade) {
        return false;
      }
      const { identityType } = JSON.parse(localStorage.getItem("userInfo"));
      if (![1, 3].includes(parseInt(identityType))) {
        return false;
      }

      return true;
    },

    /**
     * @desc 是否展示操作栏右侧评分图标按钮
     * @return {boolean}
     */
    isShowScoreRight() {
      // console.log(this.getUrlTypeInfo,'$$$',this.getFileTaskInfo.finish );
      if (this.getUrlTypeInfo !== "school") {
        return false;
      }
      const { finish } = this.getFileTaskInfo;
      if (parseInt(finish) !== 1) {
        return false;
      }
      return true;
    },

    //获取url中的type信息
    getUrlTypeInfo() {
      const { type } = this.getUrlInfo;
      return type ? type : "";
    },

    //获取主题
    themeClass() {
      return `operation-area-inside-${this.getThemeInfo}`;
    },

    /**
     * @desc 是否展示退回任务按钮
     * @return {boolean}
     */
    isShowBankTask() {
      const { taskType } = this.getUrlInfo;
      // 任务详情信息的finish
      const { finish: taskFinish } = this.getFileTaskInfo;
      // 文件信息的finish 项目管理详情进入才会调用接口拿到参数
      const { finish: fileFinish } = this.getFileInfo;
      // const { ifOnlyPreview } = this.getTaskContentList
      if (
        this.getUrlTypeInfo === "task" &&
        [2, 3].includes(taskType) &&
        taskFinish !== 1
      ) {
        // 我的任务进入
        // && ifOnlyPreview === 0
        return true;
      } else if (this.getUrlTypeInfo === "project" && fileFinish === 1) {
        // 项目经理从项目进入
        return true;
      }
      return false;
    },

    /**
     * @desc 是否展示验收按钮
     * @return
     */
    isShowAccepted() {
      // 文件信息的finish 项目管理详情进入才会调用接口拿到参数
      const { finish } = this.getFileInfo;
      if (this.getUrlTypeInfo === "project" && finish === 1) {
        // 项目经理从项目进入
        return true;
      }
      return false;
    },
  },
  watch: {
    editorMode(val) {
      this.mark_value = val;
    },
    getFileTaskInfo: {
      handler(newVal, oldVal) {
        if (newVal && !Object.keys(oldVal).length) {
          const { finish } = newVal;
          if (this.getUrlTypeInfo === "school" && parseInt(finish) === 1) {
            // 获取评价状态
            const { taskId } = this.getUrlInfo;
            this.$store.dispatch("editor/updateEvaluationResults", { taskId });
          }
        }
      },
      deep: true,
    },
  },

  mounted() {
    // 文字大小缓存
    this.setEditorFontSize();
    this.queryRouteInof =
      JSON.parse(this.$Base64.decode(this.$route.query.key)) || {};

    // 浏览模式 展示
    const { fileSuffix, type } = this.queryRouteInof;
    const fileSuffixList = ["doc", "docx", "txt", "pdf"];
    //   if (type === 'school') {
    //   this.editorViewMode.forEach(item => {
    //     item.isShow = item.title === '表格对照' ? true : false
    //   })
    // } else
    if (["task", "project"].includes(type)) {
      if (!fileSuffixList.includes(fileSuffix)) {
        this.editorViewMode.forEach((item) => {
          item.isShow = item.title === "左右对照" ? false : true;
        });
      }
    }
    //  每次进入存储当前预览模式
    let obj = { id: 1, name: "newEditor", title: "表格对照" };
    this.$store.commit("editor/update_current_view_mode", obj);
    this.$nextTick(() => {
      // 键盘事件监听
      document.addEventListener("keydown", this.handleKeydown);
    });
  },

  destroyed() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    handleRedoClose() {
      this.redoVisible = false;
    },
    handleRedoConfirm() {
      this.redoVisible = false;
    },
    handleScoreClose() {
      this.scoreVisible = false;
    },
    handleScoreConfirm() {
      this.scoreVisible = false;
    },

    // 退回任务
    handleBankTask() {
      this.bankTaskVisible = true;
    },
    handleBankTaskClose() {
      this.bankTaskVisible = false;
    },
    /**
     * @desc 确定退回任务回调
     * @param {Array} checkedIdList  选中退回人的id集合
     */
    async handleBankTaskConfirm({ checkedIdList: idList }) {
      if (this.getUrlTypeInfo === "project") {
        // 项目经理从项目进入
        // console.log(this.getUrlInfo, 'this.getUrlInfo');
        const { projectProcessType: taskType } = this.getProjectInfo;
        const params = {
          idList,
          taskType,
        };
        const { success } = await rollBackTask(params);
        if (!success) return;
        this.bankTaskVisible = false;
        window.location.reload();
      } else if (this.getUrlTypeInfo === "task") {
        const { fileId, id, taskType } = this.getFileTaskInfo;
        const params = {
          fileId,
          id,
          idList,
          taskId: id,
          taskType,
        };
        const { success } = await rollBackTaskToSent(params);
        if (!success) return;
        this.bankTaskVisible = false;
        window.location.reload();
      }
    },

    handleAcceptedClose() {
      this.acceptedVisible = false;
    },
    // 确认验收
    async handleAcceptedConfirm() {
      const { id: fileId } = this.getFileInfo;
      const params = {
        fileId,
        taskType: 0,
      };
      const { success } = await acceptanceTask(params);
      if (!success) return;
      this.acceptedVisible = false;
      window.setTimeout(() => {
        window.location.reload();
      }, 500);
    },

    /**
     * @desc 预览模式切换
     */
    handleChangeViewMode(item) {
      let { name, id, title } = item;
      let fileSuffixList = ["xlsx", "xls"];
      const { fileSuffix } = this.queryRouteInof;
      if (
        id === 2 &&
        title === "上下对照" &&
        fileSuffixList.includes(fileSuffix)
      ) {
        name = "editorXls";
      }
      if (name !== "newEditor") {
        let taskContentListParams =
          this.$store.getters["editor/getTaskContentListParams"];
        if (
          taskContentListParams.hasComment ||
          taskContentListParams.transStatus ||
          taskContentListParams.hasRepeatLock
        ) {
          taskContentListParams.hasComment = "";
          taskContentListParams.transStatus = "";
          taskContentListParams.hasRepeatLock = "";
        }
        Reflect.set(taskContentListParams, "startSort", 1);
        if (this.getUrlTypeInfo == "project") {
          this.$store.dispatch("editor/getFileContent", taskContentListParams);
        } else {
          this.$store.dispatch("editor/getTaskContent", taskContentListParams);
        }
      }
      this.$store.commit("editor/update_current_view_mode", item);
      this.$router.replace({
        name,
        query: {
          key: this.$Base64.encode(JSON.stringify(this.queryRouteInof)),
          importOption: this.$Base64.encode(JSON.stringify(this.importOption)),
        },
      });
    },

    //键盘事件
    handleKeydown(e) {
      if (e.ctrlKey && e.keyCode === 70) {
        console.log("Ctrl+F");
        eventUtil.preventDefault(e);
        this.handleClick("first");
      } else if (e.altKey && e.keyCode === 84) {
        //添加术语 alt + t
        console.log("Alt+T");
        eventUtil.preventDefault(e);
        // let urlTypeInfo = this.getUrlTypeInfo;
        // if (urlTypeInfo !== "school") {
        this.handleClick("second");
        // }
      }
    },

    // 撤销revokeInfo
    handleRetreat() {
      let timer = window.setTimeout(() => {
        clearTimeout(timer);
        const self = this;
        let FragmentTermInfo =
          self.$store.getters["editor/getFragmentTermInfo"];
        let fileId = null;
        if (this.getUrlTypeInfo === "project") {
          fileId = this.getFileInfo.id;
        } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
          fileId = this.getFileTaskInfo.fileId;
        }
        let keysArray = [...this.getRevokeInfo.keys()].sort();
        let fragments = JSON.parse(JSON.stringify(FragmentTermInfo));
        if (this.getRevokeInfo && this.getRevokeInfo.size) {
          let currentInfo = this.getRevokeInfo.get(
            keysArray[keysArray.length - 1]
          );
          const findItem = this.getTaskContentList.transSentRespVoList.find(
            (item) => item.id == currentInfo.id
          );

          if (
            (this.getProjectInfo.isSyncTransReview == 1 &&
              findItem.status == 3) ||
            findItem.status == 4 ||
            findItem.status == 5
          ) {
            //译审同步 已确认的句子不能撤回
            this.$message.closeAll();
            this.$message.warning("译审同步状态下，已确认的句子无法修改");
          } else if (findItem.operatorName) {
            //正在编辑的句子无法修改
            this.$message.closeAll();
            this.$message.warning("正在编辑状态下的句子无法修改");
          } else {
            let params = Object();
            let tempsource = Object();
            let tempTarget = Object();
            //恢复的目标
            Reflect.set(tempTarget, "atoms", currentInfo.TagTargetSent);
            Reflect.set(tempTarget, "sort", 0);
            Reflect.set(tempTarget, "text", null);
            Reflect.set(tempTarget, "type", null);
            //恢复的源语言
            Reflect.set(tempsource, "atoms", currentInfo.TagSourceSent);
            Reflect.set(tempsource, "sort", 0);
            Reflect.set(tempsource, "text", null);
            Reflect.set(tempsource, "type", null);
            //更新需要的数据
            Reflect.set(params, "constTime", 0);
            Reflect.set(params, "taskId", null);
            Reflect.set(params, "taskType", null);
            Reflect.set(params, "isSaveVersion", 1);
            Reflect.set(params, "sentId", currentInfo.id);
            Reflect.set(params, "content", currentInfo.content);
            Reflect.set(params, "status", currentInfo.status);
            Reflect.set(params, "fileId", fileId);
            Reflect.set(params, "targetTagFragmentVo", tempTarget);
            Reflect.set(params, "sourceTagFragmentVo", tempsource);
            //修改成功的数据将会存入恢复数据的队列---存入到恢复的数据
            this.getRevokeInfo.delete(keysArray[keysArray.length - 1]);
            self.$store.dispatch("editor/updateTargetInfo", {
              params: params,
              type: 2,
            });
          }
        } else {
          self.$message({
            message: "没有可回撤的数据",
            type: "warning",
          });
        }
      }, 500);
    },

    // 恢复recoveryInfo
    handleAdvance() {
      const self = this;
      let FragmentTermInfo = self.$store.getters["editor/getFragmentTermInfo"];
      let fragments = JSON.parse(JSON.stringify(FragmentTermInfo));
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        fileId = this.getFileInfo.id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        fileId = this.getFileTaskInfo.fileId;
      }
      let keysArray = [...this.getRecoveryInfo.keys()].sort();
      if (this.getRecoveryInfo && this.getRecoveryInfo.size) {
        //始终获取数组的最后一位-调用更新接口
        let currentInfo = this.getRecoveryInfo.get(
          keysArray[keysArray.length - 1]
        );
        const findItem = this.getTaskContentList.transSentRespVoList.find(
          (item) => item.id == currentInfo.id
        );

        if (
          (this.getProjectInfo.isSyncTransReview == 1 &&
            findItem.status == 3) ||
          findItem.status == 4 ||
          findItem.status == 5
        ) {
          //译审同步 已确认的句子不能撤回
          this.$message.closeAll();
          this.$message.warning("译审同步状态下，已确认的句子无法修改");
        } else if (findItem.operatorName) {
          //正在编辑的句子无法修改
          this.$message.closeAll();
          this.$message.warning("正在编辑状态下的句子无法修改");
        } else {
          let params = Object();
          let tempsource = Object();
          let tempTarget = Object();
          //恢复的目标
          Reflect.set(tempTarget, "atoms", currentInfo.TagTargetSent);
          Reflect.set(tempTarget, "sort", 0);
          Reflect.set(tempTarget, "text", null);
          Reflect.set(tempTarget, "type", null);
          //恢复的源语言
          Reflect.set(tempsource, "atoms", currentInfo.TagSourceSent);
          Reflect.set(tempsource, "sort", 0);
          Reflect.set(tempsource, "text", null);
          Reflect.set(tempsource, "type", null);
          //更新需要的数据
          Reflect.set(params, "constTime", 0);
          Reflect.set(params, "taskId", null);
          Reflect.set(params, "taskType", null);
          Reflect.set(params, "isSaveVersion", 1);
          Reflect.set(params, "sentId", currentInfo.id);
          Reflect.set(params, "content", currentInfo.content);
          Reflect.set(params, "status", currentInfo.status);
          Reflect.set(params, "fileId", fileId);
          Reflect.set(params, "targetTagFragmentVo", tempTarget);
          Reflect.set(params, "sourceTagFragmentVo", tempsource);
          //删除恢复Map对象的数据---存入到撤销中
          this.getRecoveryInfo.delete(keysArray[keysArray.length - 1]);
          self.$store.dispatch("editor/updateTargetInfo", {
            params: params,
            type: 3,
          });
        }
      } else {
        self.$message({
          message: "没有可恢复的数据",
          type: "warning",
        });
      }
    },

    //向下合并
    handleDownMerge() {
      if (this.getEditorModeInfo === "mark") {
        this.$message.closeAll();
        this.$message.warning("修订模式下,不能进行向下合并操作");
        return false;
      }
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行向下合并操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行向下合并操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
      }
      // let getSourceeditStatus = self.$store.getters["editor/getSourceeditStatus"];
      // if (getSourceeditStatus === true) {
      if (this.getTempSentenceIdInfo.type === "source") {
        //获取当前句的的dom--获取句子的父级--获取当前句子兄弟
        let currentId = this.getTempSentenceIdInfo.item.id;
        let dom = document.getElementById(`source-${currentId}`);
        let parentNodeDom = dom.parentNode.parentNode;
        let parentNodeNextDom = parentNodeDom.nextSibling;
        let nextId = parentNodeNextDom.getAttribute("infoid");
        let params = Object();
        Reflect.set(params, "sourceSentId", currentId);
        Reflect.set(params, "targetSentId", parseInt(nextId));
        Reflect.set(params, "transFileId", fileId);
        this.$store.dispatch("editor/mergeFragment", params).then(() => {
          this.$store.dispatch("editor/recordCursorPosition", {});
          this.$store.dispatch("editor/setTempSentenceId", {});
        });
      } else {
        this.$message({
          message: "请先将光标定位到原文",
          type: "warning",
        });
      }
      // } else {
      //   self.$message.closeAll();
      //   self.$message({
      //     message: '请先点击编辑原文，再进行合并操作',
      //     type: 'warning'
      //   });
      // }
    },

    //拆分句子
    handleSplitFrangment() {
      if (this.getEditorModeInfo === "mark") {
        this.$message.closeAll();
        this.$message.warning("修订模式下,不能进行拆分操作");
        return false;
      }
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行拆分句子操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行拆分句子操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
      }
      // let getSourceeditStatus = this.$store.getters["editor/getSourceeditStatus"];
      // if (getSourceeditStatus === true) {
      let cursorPositionInfo =
        this.$store.getters["editor/getCursorPositionInfo"];
      if (
        this.getTempSentenceIdInfo.type === "source" &&
        !!cursorPositionInfo.length
      ) {
        let params = Object();
        cursorPositionInfo.pop();
        Reflect.set(params, "sentId", this.getTempSentenceIdInfo.item.id);
        Reflect.set(params, "transFileId", fileId);
        Reflect.set(params, "transFileSentList", cursorPositionInfo);

        this.$store.dispatch("editor/splitFragment", params).finally(() => {
          this.$store.dispatch("editor/recordCursorPosition", {});
          this.$store.dispatch("editor/setTempSentenceId", {});
        });
      } else {
        this.$message({
          message: "请先将光标定位到原文",
          type: "warning",
        });
      }
      // } else {
      //   self.$message.closeAll();
      //   self.$message({
      //     message: '请先点击编辑原文，再进行拆分操作',
      //     type: 'warning'
      //   });
      // }
    },

    //缓存取页面设置字号设置到vuex中
    setEditorFontSize() {
      let editorFontSize = parseInt(
        localStorage.getItem("editorFontSize") || 12
      );
      this.value4 = editorFontSize;
      this.$store.dispatch("editor/setEditorFontSizeInfo", editorFontSize);
    },

    //改变编辑模式
    handleEditorModeChange(value) {
      console.log(value);
      this.$emit("setEditorMode", value);
      let params = {
        column: "",
        keyword: "",
      };
      this.$store.dispatch("editor/setOerationSignInfo", params);
    },

    //确定点击标识-右侧显示具体的内容
    handleClick(value) {
      let flag = false;
      if (this.getEditorModeInfo === "standard") {
        /**1.4.6修改为任何情况下可以进行添加术语操作 */
        // if (value === "second") {//如果是点击是术语库的就进来
        //   if (this.getUrlTypeInfo === 'project') {
        //     //是否被拆分 0/1 - (未分配/分配) - (能编辑/编辑)
        //     const { finish } = this.getFileInfo
        //     if (finish === 1 && value === "second") {
        //       this.$message.closeAll();
        //       this.$message.warning("任务已提交,不能进行添加术语操作");
        //       return false;
        //     }
        //     let isSplit = !(!!parseInt(this.getFileInfo.isSplit));
        //     flag = !isSplit;
        //     // , 'school' ['task'].includes(this.getUrlTypeInfo)
        //   } else if (this.getUrlTypeInfo === 'task') {
        //     const { finish } = this.getFileTaskInfo
        //     if (finish === 1 && value === "second") {
        //       this.$message.closeAll();
        //       this.$message.warning("任务已提交,不能进行添加术语操作");
        //       return false;
        //     }
        //     let isFinish = (parseInt(finish) === 1);
        //     flag = isFinish;
        //   }
        //   if (flag) {
        //     this.$message.closeAll();
        //     this.$message({
        //       message: '锁定句子不能进行添加术语',
        //       type: 'warning'
        //     });
        //     return;
        //   }
        // }
      } else {
        if (value === "second") {
          this.$message.closeAll();
          this.$message({
            message:
              "当前正处在修订模式无法进行添加术语操作,请先切换回标准模式下进行该操作.",
            type: "warning",
          });
        }
      }
      if (this.getEditorModeInfo === "standard") {
        let params = {};
        if (value == "second") {
          params = {
            column: value,
            sourceKeyword: this.getEditorRightShownInfo.sourceKeyword,
            targetKeyword: this.getEditorRightShownInfo.targetKeyword,
          };
        } else {
          params = {
            column: value,
            source: "",
            target: "",
          };
        }
        this.$store.dispatch("editor/setOerationSignInfo", params);
        this.$store.dispatch("editor/setEditorRightActiveName", "first");
      } else {
        if (value === "first") {
          this.$message.closeAll();
          this.$message({
            message:
              "当前正处在修订模式下无法进行查找/替换操作,请先切换回标准模式下进行该操作.",
            type: "warning",
          });
          return;
        }
      }
    },

    //改变文字的大小
    hendleChange(value) {
      localStorage.setItem("editorFontSize", parseInt(value));
      this.value4 = parseInt(value);
      this.$store.dispatch("editor/setEditorFontSizeInfo", parseInt(value));
    },

    //改变锁定状态筛选
    handleChange(value, type) {
      let data = {};
      console.log(value);
      this.filterType = type;
      Reflect.set(data, "type", type);
      Reflect.set(data, "value", value);
      this.$store.dispatch("editor/changeFilter", data);
    },

    //重新机翻
    handleAfreshTranslate() {
      let fileId = null;
      //如果是项目经理从项目进入 任何时候都可以操作
      //项目经理从项目进入随时可以编辑
      let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish === 1 && !isPM) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行重新翻译操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行重新翻译操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
      }
      if (this.getEditorModeInfo === "mark") {
        this.$message.closeAll();
        return this.$message.warning("修订模式下，不能进行重新翻译操作");
      }
      let params = Object();
      if (
        Reflect.has(this.getTempSentenceIdInfo, "type") &&
        this.getTempSentenceIdInfo.type === "source"
      ) {
        let item = this.getTempSentenceIdInfo.item;
        //如果句子已确认
        const taskType = parseInt(this.getUrlInfo.taskType);
        const sentenceStatus = parseInt(item.status);
        if (taskType === 1 && !(isPM && this.getUrlInfo.type === "project")) {
          //翻译
          if (sentenceStatus === 3) {
            this.$message({
              message: "请光标先获取原文",
              type: "warning",
            });
            return false;
          }
        } else if (
          taskType === 2 &&
          !(isPM && this.getUrlInfo.type === "project")
        ) {
          //审校
          if (sentenceStatus === 4) {
            this.$message({
              message: "请光标先获取原文",
              type: "warning",
            });
            return false;
          }
        } else if (
          taskType === 3 &&
          !(isPM && this.getUrlInfo.type === "project")
        ) {
          //复审
          if (sentenceStatus === 5) {
            this.$message({
              message: "请光标先获取原文",
              type: "warning",
            });
            return false;
          }
        }
        Reflect.set(params, "sid", this.getTempSentenceIdInfo.item.id);
        Reflect.set(params, "fileId", fileId);
        this.$store.dispatch("editor/afreshTranslate", params);
      } else {
        this.$message({
          message: "请光标先获取原文",
          type: "warning",
        });
      }
    },
    //编辑原文
    handlesource() {
      if (!this.getEleStatus) {
        this.$message.closeAll();
        this.$message.warning("当前句子包含检索高亮词,不能进行编辑原文操作");
        return false;
      }
      if (this.getUrlTypeInfo === "project") {
        const { finish } = this.getFileInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行编辑原文操作");
          return false;
        }
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行编辑原文操作");
          return false;
        }
      }
      this.$store.dispatch("editor/setSourceeditEditorisSourceedit", true);
    },
    //复制到译文
    handleCopyToTarget() {
      console.log(this.getTempSentenceIdInfo, "8888888");
      //项目经理从项目进入随时可以编辑
      let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId;
      const self = this;
      if (
        Reflect.has(this.getTempSentenceIdInfo, "type") &&
        this.getTempSentenceIdInfo.type === "source"
      ) {
        if (this.getTempSentenceIdInfo.item) {
          let item = this.getTempSentenceIdInfo.item;
          //如果句子已确认
          const taskType = parseInt(this.getUrlInfo.taskType);
          const sentenceStatus = parseInt(item.status);
          if (taskType === 1 && !(isPM && this.getUrlInfo.type === "project")) {
            //翻译
            if (sentenceStatus === 3) {
              self.$message({
                message: "请光标先获取原文",
                type: "warning",
              });
              return false;
            }
          } else if (
            taskType === 2 &&
            !(isPM && this.getUrlInfo.type === "project")
          ) {
            //审校
            if (sentenceStatus === 4) {
              self.$message({
                message: "请光标先获取原文",
                type: "warning",
              });
              return false;
            }
          } else if (
            taskType === 3 &&
            !(isPM && this.getUrlInfo.type === "project")
          ) {
            //复审
            if (sentenceStatus === 5) {
              self.$message({
                message: "请光标先获取原文",
                type: "warning",
              });
              return false;
            }
          }
          const sourceTag = JSON.parse(item.tagSourceSent);
          if (
            !!sourceTag &&
            !!sourceTag.fragments &&
            !!sourceTag.fragments.length
          ) {
            let sourceTag2 = sourceTag.fragments[0].atoms;
            let targetTemp = Object();
            let fileId = null;
            if (this.getUrlTypeInfo === "project") {
              const { finish, id } = this.getFileInfo;
              if (finish === 1) {
                self.$message.closeAll();
                self.$message.warning("任务已提交,不能进行复制到译文操作");
                return false;
              }
              fileId = id;
            } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
              const { finish } = this.getFileTaskInfo;
              if (finish === 1) {
                self.$message.closeAll();
                self.$message.warning("任务已提交,不能进行复制到译文操作");
                return false;
              }
              fileId = this.getFileTaskInfo.fileId;
            }
            Reflect.set(targetTemp, "sort", 0);
            Reflect.set(targetTemp, "text", null);
            Reflect.set(targetTemp, "type", null);
            Reflect.set(targetTemp, "atoms", sourceTag2);
            let params = {};
            Reflect.set(params, "constTime", 0);
            Reflect.set(params, "taskId", null);
            Reflect.set(params, "taskType", null);
            Reflect.set(params, "isSaveVersion", null);
            Reflect.set(params, "sentId", item.id);
            Reflect.set(params, "content", item.sourceSent);
            Reflect.set(params, "status", item.status);
            Reflect.set(params, "fileId", fileId);
            Reflect.set(params, "sourceTagFragmentVo", null);
            Reflect.set(params, "targetTagFragmentVo", targetTemp);
            this.$store.dispatch("editor/updateTargetInfo", {
              params: params,
              type: 1,
            });
          }
        }
      } else {
        self.$message({
          message: "请光标先获取原文",
          type: "warning",
        });
      }
    },

    //自动填充
    handleAutoFillTag() {
      if (this.mark_value === "mark") {
        this.$message.warning("修订模式下,不能进行自动填充操作");
        return;
      }
      let params = {};
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行自动填充操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行自动填充操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
        if (this.getUrlTypeInfo === "school") {
          const { id: taskId } = this.getFileTaskInfo;
          Reflect.set(params, "taskId", taskId);
          Reflect.set(params, "taskType", this.getUrlTypeInfo);
        }
      }
      Reflect.set(params, "fileId", fileId);
      this.$store.dispatch("editor/autoFillTag", params);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>
<style lang="less">
@import "assets/global.less";
</style>
